// Components
export {
  type RenderPlaceholderProps,
  DefaultElement,
  DefaultPlaceholder,
  Editable,
  Slate,
} from 'slate-react';

// Hooks
export {
  useComposing,
  useFocused,
  useReadOnly,
  useSelected,
} from 'slate-react';

// Plugin
export { withReact } from 'slate-react';
